export function getReferrerOrigin() {
  if (!document.referrer) return null;
  try {
    const origin = new URL(document.referrer).origin;
    // Opaque origins (about:blank, file://) produce the string "null" — do not trust them.
    return origin !== 'null' ? origin : null;
  } catch (_e) {
    // Non-parseable referrer (e.g. custom-scheme WebView strings) — treat as absent.
    return null;
  }
}